import { black, blue, green, grey, latte, lavender, navy, pink, purple, red, yellow, white, transparent, } from '../colors/care-colors.js';
const palette = {
    default: {
        main: grey[900],
        dark: grey[800],
        light: grey[400],
    },
    primary: {
        main: navy[900],
        contrastText: white,
    },
    secondary: {
        main: grey[700],
        contrastText: white,
    },
    error: {
        main: red[800],
        contrastText: white,
    },
    info: {
        main: green[800],
        contrastText: white,
    },
    text: {
        primary: navy[900],
        secondary: grey[700],
        disabled: grey[300],
        hint: grey[300],
    },
    care: {
        black,
        blue,
        green,
        grey,
        latte,
        lavender,
        navy,
        pink,
        purple,
        red,
        yellow,
        white,
        transparent,
    },
    background: {
        default: white,
    },
};
export default palette;
//# sourceMappingURL=data:application/json;base64,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